import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@/../environments/environment';
import { AtividadeEvents } from '../models/atividade-events';

@Injectable({
  providedIn: 'root',
})
export class AtividadeEventsService {
  private environmentUrl: string = '';

  constructor(private httpClient: HttpClient) {
    this.environmentUrl = environment.ApiCore;
  }

  getAtividadeEventos(idAtividade: number): Observable<AtividadeEvents[]> {
    const url = `${this.environmentUrl}atividade/${idAtividade}/eventos`;
    return this.httpClient.get<AtividadeEvents[]>(url);
  }
}
